const schedule = {
  // HeroSection
  'schedule.hero.homeLink': 'ホーム',
  'schedule.hero.aboutLink': 'アカデミーについて',
  'schedule.hero.currentPage': '年間スケジュール',
  'schedule.hero.title': '年間スケジュール',
  'schedule.hero.titleEn': 'ANNUAL SCHEDULE',
  'schedule.hero.lead': '各コースは年間スケジュールに沿って開校します。お申込みは開校の14日前まで承ります。東京・お台場の執事学校として、日本執事アカデミーの開校日程を年間カレンダーで公開しています。',
  'schedule.hero.imgAlt': '壁掛けカレンダーと開校日程表を確認する受講生の様子',

  // Calendar
  'schedule.calendar.label': 'ANNUAL CALENDAR',
  'schedule.calendar.title': '年間開校カレンダー',
  'schedule.calendar.titleEn': 'Annual Course Calendar',
  'schedule.calendar.description': '各コースの開校時期を月ごとにご確認ください。開校日が確定し次第、お知らせページでご案内します。',
  'schedule.calendar.altTitle': 'いつどのコースが開校する？',
  'schedule.calendar.altDescription': '各コースは年間を通じて、季節ごとに開校します。お仕事やご予定に合わせて、受講しやすい時期をお選びください。',
  'schedule.calendar.footerNote': '※開校日が決定し次第、お知らせページでご案内します',
  'schedule.calendar.yearEnd.subLabel': 'YEAR-END BREAK',
  'schedule.calendar.month.1': '1月',
  'schedule.calendar.month.2': '2月',
  'schedule.calendar.month.3': '3月',
  'schedule.calendar.month.4': '4月',
  'schedule.calendar.month.5': '5月',
  'schedule.calendar.month.6': '6月',
  'schedule.calendar.month.7': '7月',
  'schedule.calendar.month.8': '8月',
  'schedule.calendar.month.9': '9月',
  'schedule.calendar.month.10': '10月',
  'schedule.calendar.month.11': '11月',
  'schedule.calendar.month.12': '12月',
  'schedule.calendar.course.essential': 'エッセンシャル',
  'schedule.calendar.course.advanced': 'アドバンス',
  'schedule.calendar.course.master': 'マスター',
  'schedule.calendar.course.break': '休校',
  'schedule.calendar.course.double': 'マスター／アドバンス',
  'schedule.calendar.desc.essential': '基礎の所作と接遇の型を集中的に学ぶ入門コース',
  'schedule.calendar.desc.advanced': 'ワインサービスやイベント運営など専門技能を磨く中級コース',
  'schedule.calendar.desc.master': '管理・危機対応・国際プロトコルまでを網羅する最上級コース',
  'schedule.calendar.desc.break': '体験講座・法人研修に充当する期間です',
  'schedule.calendar.desc.double': 'マスターコース終盤とアドバンスコースが重なる開校月です',
  'schedule.calendar.yearEnd.label': '年末年始',
  'schedule.calendar.yearEnd.courseLabel': '休校',
  'schedule.calendar.yearEnd.description': '年末年始は全コースを休講とします。新年1月よりエッセンシャルコースが開校します。',

  // CourseFlow
  'schedule.duration.structure': 'COURSE STRUCTURE',
  'schedule.duration.flowTitle': '各コースの開校概要',
  'schedule.duration.flowDescription': 'すべてのコースは土日開催・1日6時間（90分×4コマ）の集中カリキュラムで構成されています。お仕事を続けながらでも無理なくご受講いただける設計です。執事養成学校に何年かかるかという点では、日本の執事学校の課程はエッセンシャル約1ヶ月（8日間48時間）・アドバンス約2ヶ月（12日間72時間）・マスター約3ヶ月（16日間96時間）から選べます。',
  'schedule.duration.viewLink': 'コース詳細を見る',

  // ApplicationDeadline section header
  'schedule.app.label': 'APPLICATION',
  'schedule.app.title': '申込締切と定員',
  'schedule.app.titleEn': 'Deadlines & Capacity',
  'schedule.app.description': 'お申込みは各開校日の14日前まで承ります。完全少人数制のため、定員に達し次第締め切らせていただきます。',
  'schedule.app.footerNote': '※最少催行人数3名に満たない場合は、開校を見送ることがあります。その際の対応は募集要項に従います。',

  // BreakPeriod
  'schedule.break.title': '休校期のご案内',
  'schedule.break.titleEn': 'Off-Season Programs',
  'schedule.break.description': '8月と年末年始は本科コースを休講とし、この期間に体験講座や法人研修を実施する予定です。スキルアップや企業研修のご検討にぜひご活用ください。',
  'schedule.break.seminar.title': '体験講座',
  'schedule.break.seminar.desc': '1日で執事の所作を体験できる入門講座。本科コースの雰囲気を知りたい方におすすめです。',
  'schedule.break.seminar.link': '詳細を見る',
  'schedule.break.corporate.title': '法人研修',
  'schedule.break.corporate.desc': '企業向けの接遇・ビジネスマナー研修。業種別にカスタマイズしたプログラムをご提案します。',
  'schedule.break.corporate.link': '詳細を見る',

  // CTASection
  'schedule.cta.courses': 'コースを見る',

  // CourseDuration
  'schedule.duration.label': 'COURSE DURATION',
  'schedule.duration.title': 'コースごとの日数・時間',
  'schedule.duration.titleEn': 'Course Duration at a Glance',
  'schedule.duration.col.days': '日数',
  'schedule.duration.col.hours': '時間',
  'schedule.duration.col.weeks': '期間',
  'schedule.duration.col.schedule': '開校月',
  'schedule.duration.viewCourse': 'コース詳細',
  'schedule.duration.0.name': 'エッセンシャルコース',
  'schedule.duration.0.days': '8日間',
  'schedule.duration.0.hours': '48時間',
  'schedule.duration.0.weeks': '約1ヶ月',
  'schedule.duration.0.schedule': '7月・1月開校',
  'schedule.duration.1.name': 'アドバンスコース',
  'schedule.duration.1.days': '12日間',
  'schedule.duration.1.hours': '72時間',
  'schedule.duration.1.weeks': '約2ヶ月',
  'schedule.duration.1.schedule': '5〜6月・11〜12月開校',
  'schedule.duration.2.name': 'マスターコース',
  'schedule.duration.2.days': '16日間',
  'schedule.duration.2.hours': '96時間',
  'schedule.duration.2.weeks': '約3ヶ月',
  'schedule.duration.2.schedule': '2〜4月・9〜11月開校',

  // CommonInfo
  'schedule.info.label': 'COMMON INFO',
  'schedule.info.title': '共通事項',
  'schedule.info.titleEn': 'Schedule & Policies',
  'schedule.info.0': 'すべての授業を土日に開催。1日6時間（90分×4コマ）の集中カリキュラムです。',
  'schedule.info.1': '完全少人数制（定員6名）。最少催行人数は3名です。',
  'schedule.info.2': 'お申込み締切は各開校日の14日前。定員に達し次第、受付を締め切ります。',
  'schedule.info.3': 'お支払いは銀行振込による一括払いのみ。分割払い・クレジットカードはご利用いただけません。',

  // FAQSection
  'schedule.faq.label': 'FAQ',
  'schedule.faq.title': 'よくあるご質問',
  'schedule.faq.titleEn': 'Frequently Asked Questions',
  'schedule.faq.footer': 'その他のご質問はフォームよりお寄せください',
  'schedule.faq.0.question': '各コースはいつ開校しますか？',
  'schedule.faq.0.answer': 'マスターは2〜4月と9〜11月、アドバンスは5〜6月と11〜12月、エッセンシャルは7月と1月に開校予定です。8月と年末年始は休校です。',
  'schedule.faq.1.question': '申込の締切はいつですか？',
  'schedule.faq.1.answer': '各開校日の14日前までです。定員6名に達した時点で締め切ります。',
  'schedule.faq.2.question': '具体的な日程はどこで分かりますか？',
  'schedule.faq.2.answer': '開校日が決まり次第、お知らせページでご案内します。資料請求や個別相談でも最新の予定をお伝えできます。',

  // CTASection
  'schedule.cta.label': 'APPLY NOW',
  'schedule.cta.title': 'まずは資料請求・個別相談を',
  'schedule.cta.body': '開校日程の詳細は資料請求・個別相談でお伝えします。お気軽にどうぞ。',
  'schedule.cta.note': '※ご相談はオンラインでも承ります',
  'schedule.cta.brochure': '資料請求はこちら（無料）',
  'schedule.cta.consultation': '個別相談を予約する',

  // RelatedPages
  'schedule.related.label': 'LEARN MORE',
  'schedule.related.title': '関連ページ',
  'schedule.related.titleEn': 'Explore Further',
  'schedule.related.viewLink': '詳しく見る',
  'schedule.related.0.title': 'コース一覧・比較',
  'schedule.related.0.desc': '3コースの違いを一覧で確認',
  'schedule.related.1.title': 'エッセンシャルコース',
  'schedule.related.1.desc': '基礎から始める入門課程',
  'schedule.related.2.title': 'アドバンスコース',
  'schedule.related.2.desc': '専門技能を磨く中級課程',
  'schedule.related.3.title': 'マスターコース',
  'schedule.related.3.desc': '管理・危機対応まで修める最上級課程',
  'schedule.related.4.title': '入学案内概要',
  'schedule.related.4.desc': '入学の流れと応募資格',

  // Last updated
  'schedule.lastUpdated': '最終更新: 2026年7月8日',
};

export default schedule;
